import { useTheme } from '@mui/material/styles';
import { GridColTypeDef, GridRenderCellParams } from "@mui/x-data-grid";
import { useTranslation } from 'react-i18next';

import distributionBarColumn, { DistributionBarOptions, renderDistributionBarColumn } from "./DistributionBarColumn";

export interface SentimentBarOptions {
  headerLabels?: Record<string, string>;
}

function sentimentBarColumn(options?: SentimentBarOptions): GridColTypeDef {
  return {
    ...distributionBarColumn(options),
    renderCell: (params: GridRenderCellParams) => {
      const theme = useTheme();
      const { i18n } = useTranslation();
      const sentimentBarOptions: DistributionBarOptions = {
        backgroundColor: theme.colors.namedColors.negative,
        fillColor: theme.colors.namedColors.positive,
        headerLabels: options?.headerLabels
      };
      return renderDistributionBarColumn(i18n, theme, params, sentimentBarOptions);
    },
  };
}

export default sentimentBarColumn;
